export { modalsIntlIds } from './modals.ids';
